module.exports = __webpack_public_path__ + "img/ufo-beam.bd160b78.svg";